import React from 'react'
import LgyLink from 'app/components/util/lgy-link/LgyLink'

/**
 * Displays the headline of an announcement as a clickable link
 * 
 * @param {Object} announcement the announcement to render
 * @author Alex Clary
 * @since 20.4.5
 * @prettier
 */
const AnnouncementHeadline = ({ announcement }) => {

  const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  // An announcements counts as being new if it's less than a week old
  const isNewAnnouncement = announcement.beginDate > oneWeekAgo

  return <span style={{ fontWeight: isNewAnnouncement ? 'bold' : 'normal' }}>
    {isNewAnnouncement && <span className='new-announcement'>(NEW) </span>}
    <LgyLink to={`/lgyhub/announcements/${announcement.id}`}>
    <span>
      {(new Date(announcement.beginDate)).toLocaleDateString()}
      {': '}
      {announcement.headline}
    </span>
  </LgyLink>
  </span>
}

export default AnnouncementHeadline